/*global __CLIENT__*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import '../styles/Collapse.css';

export default class Collapse extends PureComponent {
  constructor(props) {
    super(props);
    this.onHeaderClick = this.onHeaderClick.bind(this);
  }

  // state = {
  //   open: (this.props.open) ? true : false
  // };

  static propTypes = {
    header: PropTypes.string.isRequired,
  };

  onHeaderClick() {
    if (this.props.stateAction) {
      this.props.stateAction();
    }

    // if(this.props.children){
    //   this.setState({open: !this.props.open});
    // }
  }

  render() {
    const classes = classNames({
      hide: !this.props.open,
      'collapse-child': (this.props.level === 1),
      'collapse-child-second': (this.props.level === 2),
    });

    const iconClasses = classNames({
      fa: true,
      'fa-chevron-right': !this.props.open,
      'fa-chevron-down': this.props.open,
      'pull-right': true,
    });

    const style = {
      paddingLeft: this.props.level ? '40px' : '0px',
    };

    const helpText = this.props.help ? <small className="text-muted">{this.props.help}</small> : null;
    const addButton = this.props.addAction ? <button onClick={this.props.addAction} type="button" className="action-btn btn btn-success btn-sm"><i className="fa fa-plus"></i></button> : null;
    const renameButton = this.props.renameAction ? <button onClick={this.props.renameAction} type="button" className="action-btn btn btn-info btn-sm"><i className="fa fa-pencil-square-o"></i></button> : null;
    const deleteButton = this.props.deleteAction ? <button onClick={this.props.deleteAction} type="button" className="action-btn btn btn-danger btn-sm"><i className="fa fa-trash-o"></i></button> : null;
    const settingsButton = this.props.settingsAction ? <button onClick={this.props.settingsAction} type="button" className="action-btn btn btn-outline-secondary btn-sm"><i className="fa fa-cog"></i></button> : null;

    const actionButtons = (addButton || renameButton || deleteButton || settingsButton) ? <div className="btn-group" role="group" style={{ float: 'right', paddingLeft: 10, paddingRight: 10 }}>{settingsButton}{addButton}{renameButton}{deleteButton}</div> : null;

    const chevronPixels = (!this.props.open) ? 4 : 0;
    const collapseArrow = <i className={iconClasses} />;
    //const collapseArrow = this.props.children ? <i style={{ float: 'right', paddingRight: chevronPixels }} className={iconClasses}></i> : '';

    return (
      <div className="collapse-container">
        <div className="d-flex justify-content-end">
          <h3 className="panel-title collapse-header noselect mr-auto pr-1" onClick={this.onHeaderClick}>
            {this.props.header} {helpText}
          </h3>
          <div className="actions-container" style={{ paddingRight: chevronPixels }}>
            {collapseArrow}
            {actionButtons}
          </div>
        </div>
        <div className={classes} style={style}>{this.props.children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Collapse.js